import { createAsyncThunk } from "@reduxjs/toolkit";
import { logoutUser } from "./authThunks";

const API_BASE = process.env.REACT_APP_API_BASE;
const API_KEY = process.env.REACT_APP_API_KEY;

/**
 * fetch all Featuredvendors entries
 */
export const fetchFeaturedvendorsItems = createAsyncThunk(
  "featuredvendors/fetchItems",
  async (_, thunkAPI) => {
    const res = await fetch(`${API_BASE}/api/featuredvendors`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
             "x-api-key": API_KEY,
      },
    });
    // if (res.status === 401) {
    //   thunkAPI.dispatch(logoutUser());
    //   window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
    //   return thunkAPI.rejectWithValue("Unauthorized");
    // }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);
